import React, { Component } from 'react';
import {toJS} from 'mobx';
import { inject, observer } from 'mobx-react';

//api
import {api} from '../../../functions/api'

//custom components
import CustomTabs from '../../../components/basic/customTabs'
import BasicInfo from './basic/BasicInfo';
import ContactInfo from './ContactInfo2/ContactInfo2';
import BussniessHours from './bussniesHours/BussniessHours'
import Seo from './seo/Seo'
import OurStory from './ourStory/OurStory';

//material-ui
import { CircularProgress } from '@material-ui/core';

//other libraries

@inject('internal')
@inject('translate')
@observer
export default class ShopDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
        }
    }

    tabsConfig = [
        {
            label: this.props.translate.i18n.MODULES.SHOPS.BASIC_INFO,
            url: "basic"
        },
        {
            label: this.props.translate.i18n.MODULES.SHOPS.BUSSNIESS_HOURS,
            url: "bussniess-hours"
        },
        {
            label: this.props.translate.i18n.MODULES.SHOPS.CONTACT,
            url: "contact"
        },
        {
            label: this.props.translate.i18n.MODULES.SHOPS.SEO,
            url: "seo"
        },
        {
            label: this.props.translate.i18n.MODULES.SHOPS.OUR_STORY,
            url: "our-story"
        },
    ]

    componentDidMount() {
        this.props.internal.setRoute( this.props.history, this.props.location.pathname)
        this.loadShopDetail()
        this.loadCountries()
    }

    loadShopDetail = async() => {
        let id = this.props.match.params.id
        let load_data = await api({
            method: 'get',
            url: `lists/shops/${id}`,
            authorization: this.props.internal.user.access_token,
        })

        if(load_data.success === true) {
            this.props.internal.setDataForTable(load_data.data.data)
            this.setState({loading: false})
        }
    }

    loadCountries = async() => {
        let load_countries = await api ({
            method: 'GET',
            url: 'lists/countries',
            authorization: this.props.internal.user.access_token,
        })

        if(load_countries.success === true) {
            this.props.internal.setCountries(load_countries.data.data)
        }
    }

    render () {
        const routerData = {
            history: this.props.history,
            location: this.props.location,
            match: this.props.match
        }

        return (
            <div className={'client-detail-container'}>
                {this.state.loading ? 
                    <CircularProgress className={'circular-progress'} /> 
                    : 
                    <div className={'clients-details'}>
                        <CustomTabs 
                            title={toJS(this.props.internal.dataForTable.name)} 
                            tabsConfig={this.tabsConfig } 
                            routerData={routerData}
                            module={'/shops'}
                            >
                            {this.state.loading ? null : 
                                <BasicInfo routerData={routerData}></BasicInfo>
                            }
                            {this.state.loading ? null : 
                                <BussniessHours routerData={routerData}></BussniessHours>
                            }
                            {this.state.loading ? null : 
                                <ContactInfo routerData={routerData}></ContactInfo>
                            }
                            {this.state.loading ? null : 
                                <Seo routerData={routerData}></Seo>
                            }
                            {this.state.loading ? null : 
                                <OurStory routerData={routerData}></OurStory>
                            }
                        </CustomTabs>
                    </div>
                }
        </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/screens/shops/detail/index.jsx